import React, { useRef, useState } from "react";

import SearchIcon from "@mui/icons-material/Search";
import ClearIcon from "@mui/icons-material/Clear";
import { Box, FormControl, InputAdornment, TextField } from "@mui/material";

interface SearchProps {
  filter: (filter: string) => void;
}


const Search = (props: SearchProps) => {
  const [showClearIcon, setShowClearIcon] = useState("none");
  const [value, setValue] = useState("");

  const inputRef = useRef<any>(null);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>): void => {
    setShowClearIcon(event.target.value === "" ? "none" : "flex");
    const filteredValue = event.target.value.replace(/[^0-9]/g, "");
    setValue(filteredValue)
    props.filter(event.target.value)
  };

  const handleClick = (): void => {
    if (inputRef.current) {
      setValue("")
      setShowClearIcon("none");
    }
    props.filter('')
  };

  return (
    <Box sx={{ width: 160, marginRight: 1}}>
      <FormControl>
        <TextField
          inputRef={inputRef}
          size="small"
          variant="outlined"
          value={value}
          onChange={handleChange}
          placeholder="localId"
          onClick={(e) => e.stopPropagation()}
          InputProps={{
            onClick: (e) => e.stopPropagation(),
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            ),
            endAdornment: (
              <InputAdornment
                position="end"
                style={{ display: showClearIcon }}
                onClick={handleClick}
              >
                <ClearIcon />
              </InputAdornment>
            ),
          }}
        />
      </FormControl>
    </Box>
  );
};

export default Search;
